// extracted by mini-css-extract-plugin
export default {"checkbox-label":"radio-button_checkbox-label__jJzD1","container":"radio-button_container__bJJ8j","sub-label":"radio-button_sub-label__pLnVH"};